import React, { useContext } from "react";
import "../../styles/partners.css";
import DetailHead from "./DetailsHead";
import { LanguageContext } from "../../App";
import TEXT from "../../data/text";

const Partners = ({ allPartners }) => {
  const { language } = useContext(LanguageContext);
  return (
    <div className="partner_details container">
      <div className="et_pb_section partner_section et_pb_section_parallax et_pb_with_background et_section_regular section_has_divider judges_bottom_divider judges_top_divider">
        <DetailHead title={TEXT[language]["SUSTAINATHONS"]["11"]} />
        {allPartners && allPartners.length > 0 ? (
          allPartners.map((Mainpartner, index) => {
            return (
              <div key={index} className="partners_wrap partners_section">
                <div className="partner_title">
                  <h3>{Mainpartner.title}</h3>
                </div>
                <div className="partner_imgs">
                  {Mainpartner.partners && Mainpartner.partners.length > 0
                    ? Mainpartner.partners.map((partner, index) => {
                        return (
                          <a
                            href={partner.redirectUrl}
                            className="part_img_main"
                            target="_blank"
                            key={index}
                          >
                            <img
                              className="part_img img-fluid"
                              src={partner.imageUrl}
                              alt="spartner"
                            />
                          </a>
                        );
                      })
                    : ""}
                </div>
              </div>
            );
          })
        ) : (
          <h3>{TEXT[language]["SUSTAINATHONS"]["6"]}</h3>
        )}
      </div>
    </div>
  );
};

export default Partners;
